<svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20.1358 9.54684C20.0143 9.4703 19.8674 9.56568 19.8674 9.70929V12.7532C19.8674 12.8968 20.0143 12.9922 20.1358 12.9157C20.7025 12.5587 21.0571 11.9244 21.0571 11.2313C21.0571 10.5382 20.7025 9.90377 20.1358 9.54684Z" fill="currentColor"/>
<rect x="3.42505" y="8.4292" width="9.11425" height="5.1417" rx="1" fill="currentColor"/>
<rect x="1.5873" y="6.65676" width="16.5458" height="8.68651" rx="2.15" stroke="currentColor" stroke-width="1.7"/>
</svg>
